import { render } from "./UserLoanList.vue?vue&type=template&id=7184fc19&scoped=true"
import script from "./UserLoanList.vue?vue&type=script&lang=js"
export * from "./UserLoanList.vue?vue&type=script&lang=js"

import "./UserLoanList.vue?vue&type=style&index=0&id=7184fc19&scoped=true&lang=css"

import exportComponent from "/Users/afolabitope/Documents/apps/redge/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7184fc19"]])

export default __exports__